module.exports = __webpack_public_path__ + "img/certificate7.0a83ae63.png";